import { authApi } from "./userApi";
import type { UserAvatar } from "../model/types";

const AVATAR_URL = "/users/profile/avatar";
const AVATAR_FORM_FIELD = "file";

interface AvatarResponse {
  avatar: UserAvatar;
  message: string;
}

type Dispatch = (
  action: ReturnType<typeof authApi.util.updateQueryData>,
) => unknown;

// URL аватара содержит uuid и меняется при каждой загрузке — кладём новый
// аватар из ответа сразу в кэш профиля, без повторного запроса всего профиля.
const syncProfileAvatar = async (
  dispatch: Dispatch,
  queryFulfilled: Promise<{ data: AvatarResponse }>,
) => {
  try {
    const { data } = await queryFulfilled;
    dispatch(
      authApi.util.updateQueryData("getUserData", undefined, (profile) => {
        profile.avatar = data.avatar;
      }),
    );
  } catch {
    // Ошибку запроса обрабатывает вызывающий код через результат мутации.
  }
};

const avatarApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadUserAvatar: builder.mutation<AvatarResponse, File>({
      query: (file) => {
        const body = new FormData();
        body.append(AVATAR_FORM_FIELD, file);
        return { url: AVATAR_URL, method: "POST", body };
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) =>
        syncProfileAvatar(dispatch, queryFulfilled),
    }),
    removeUserAvatar: builder.mutation<AvatarResponse, void>({
      query: () => ({ url: AVATAR_URL, method: "DELETE" }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) =>
        syncProfileAvatar(dispatch, queryFulfilled),
    }),
  }),
});

export const { useUploadUserAvatarMutation, useRemoveUserAvatarMutation } =
  avatarApi;
